import './lib/sentry-instrument';
import { createRoot } from 'react-dom/client';
import App from './App';
import './pdfWorker';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<App />);
